import React, { useEffect } from 'react';

const Snackbar = ({ message, type = 'info', onClose, duration = 3000 }) => {
  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      
      return () => clearTimeout(timer);
    }
  }, [duration, onClose]);

  const getTypeClass = () => {
    switch (type) {
      case 'success':
        return 'is-success';
      case 'error':
        return 'is-danger';
      case 'warning':
        return 'is-warning';
      default:
        return 'is-info';
    }
  };

  return (
    <div 
      className={`notification ${getTypeClass()}`}
      style={{
        position: 'fixed',
        bottom: '20px',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 9999,
        minWidth: '300px',
        maxWidth: '500px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.4)',
        animation: 'slideUp 0.3s ease-out',
        color: 'white',
        fontWeight: '600'
      }}
    >
      <button className="delete" onClick={onClose}></button>
      <div>
        {message}
      </div>
      <style>{`
        @keyframes slideUp {
          from {
            transform: translateX(-50%) translateY(100px);
            opacity: 0;
          }
          to {
            transform: translateX(-50%) translateY(0);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
};

export default Snackbar;
